import request, { requestV2, requestV1 } from "@/config/serve.js";
// 查询
export function getCategoryList(params) {
  return request("post", "/apiGo/api/v1/apkPromotionPosBehavior/gp/list", {
    deleted: false,
    ...params,
  });
}
// 下载来源
export function getDownloadSource(params = {}, loading = false) {
  return requestV1(
    "post",
    "/oobeReport/dropDownList",
    {
      deleted: false,
      ...params,
    },
    loading
  );
}
//商务人员管理列表
export function getBusinessManagerList(params) {
  return request("post", "/honorManageUser/businessManage", params);
}
// 获取开发者
export function getDeveloperUserList(params) {
  return requestV2("post", "/api/v1/ozCms/gp/listDev", params);
}
